var MAUIMODES = /* @__PURE__ */ ((MAUIMODES2) => {
  MAUIMODES2["edit"] = "edit";
  MAUIMODES2["clone"] = "clone";
  MAUIMODES2["create"] = "create";
  MAUIMODES2["add"] = "add";
  return MAUIMODES2;
})(MAUIMODES || {});
var MAUIDraftEntityPaths = /* @__PURE__ */ ((MAUIDraftEntityPaths2) => {
  MAUIDraftEntityPaths2["metric"] = "metric";
  MAUIDraftEntityPaths2["column"] = "column";
  MAUIDraftEntityPaths2["segment"] = "segment";
  MAUIDraftEntityPaths2["template"] = "template";
  MAUIDraftEntityPaths2["enrichment"] = "enrichment";
  MAUIDraftEntityPaths2["analysis"] = "analysis";
  MAUIDraftEntityPaths2["scorecards"] = "scorecards";
  MAUIDraftEntityPaths2["scorecard"] = "scorecard";
  MAUIDraftEntityPaths2["preview"] = "preview";
  MAUIDraftEntityPaths2["analysis-template"] = "analysis-template";
  MAUIDraftEntityPaths2["configuration"] = "configuration";
  MAUIDraftEntityPaths2["metric-health"] = "metric-health";
  MAUIDraftEntityPaths2["publish-history"] = "publish-history";
  MAUIDraftEntityPaths2["preview-scorecard"] = "preview-scorecard";
  MAUIDraftEntityPaths2["metric-template"] = "metric-template";
  return MAUIDraftEntityPaths2;
})(MAUIDraftEntityPaths || {});
var MAUIPivotNames = /* @__PURE__ */ ((MAUIPivotNames2) => {
  MAUIPivotNames2["CustomColumns"] = "Custom columns";
  MAUIPivotNames2["Metrics"] = "Metrics";
  MAUIPivotNames2["ComputationTemplates"] = "Computation templates";
  MAUIPivotNames2["Segments"] = "Segments";
  MAUIPivotNames2["ScorecarLayouts"] = "Scorecard layouts";
  MAUIPivotNames2["Enrichments"] = "Enrichments";
  MAUIPivotNames2["AnalysisTemplates"] = "Analysis templates";
  MAUIPivotNames2["Configuration"] = "Configuration";
  MAUIPivotNames2["MetricSetHealth"] = `Metric set health`;
  MAUIPivotNames2["PublishHistory"] = "Publish history";
  MAUIPivotNames2["PreviewScorecard"] = "Preview scorecard";
  return MAUIPivotNames2;
})(MAUIPivotNames || {});
var MAUIEntityPaths = /* @__PURE__ */ ((MAUIEntityPaths2) => {
  MAUIEntityPaths2["metric"] = "metric";
  MAUIEntityPaths2["column"] = "column";
  MAUIEntityPaths2["segment"] = "segment";
  MAUIEntityPaths2["template"] = "template";
  MAUIEntityPaths2["enrichment"] = "enrichment";
  MAUIEntityPaths2["analysis"] = "analysis";
  MAUIEntityPaths2["scorecards"] = "scorecards";
  MAUIEntityPaths2["scorecard"] = "scorecard";
  MAUIEntityPaths2["preview"] = "preview";
  MAUIEntityPaths2["analysis-template"] = "analysis-template";
  MAUIEntityPaths2["configuration"] = "configuration";
  MAUIEntityPaths2["setup"] = "setup";
  MAUIEntityPaths2["metric-health"] = "metric-health";
  MAUIEntityPaths2["publish-history"] = "publish-history";
  MAUIEntityPaths2["preview-scorecard"] = "preview-scorecard";
  return MAUIEntityPaths2;
})(MAUIEntityPaths || {});
var MAUIConfigurationPaths = /* @__PURE__ */ ((MAUIConfigurationPaths2) => {
  MAUIConfigurationPaths2["data-source"] = "data-source";
  MAUIConfigurationPaths2["aggregation-level"] = "aggregation-level";
  MAUIConfigurationPaths2["exp-setup"] = "exp-setup";
  MAUIConfigurationPaths2["git-repo-setup"] = "git-repo-setup";
  MAUIConfigurationPaths2["access-control-setup"] = "access-control-setup";
  MAUIConfigurationPaths2["analysis-defaults"] = "analysis-defaults";
  MAUIConfigurationPaths2["preview-scorecard-settings"] = "preview-scorecard-settings";
  return MAUIConfigurationPaths2;
})(MAUIConfigurationPaths || {});
var MAUIEnrichmentPaths = /* @__PURE__ */ ((MAUIEnrichmentPaths2) => {
  MAUIEnrichmentPaths2["Alerts"] = "Alerts";
  MAUIEnrichmentPaths2["SeedFinder"] = "SeedFinder";
  MAUIEnrichmentPaths2["TrafficFilterDimensionMap"] = "TrafficFilterDimensionMap";
  return MAUIEnrichmentPaths2;
})(MAUIEnrichmentPaths || {});
var MAUIMetricHealthPaths = /* @__PURE__ */ ((MAUIMetricHealthPaths2) => {
  MAUIMetricHealthPaths2["constant-value-metrics"] = "constant-value-metrics";
  MAUIMetricHealthPaths2["inactive-metrics"] = "inactive-metrics";
  MAUIMetricHealthPaths2["outlier"] = "outlier";
  MAUIMetricHealthPaths2["sensitivity"] = "sensitivity";
  MAUIMetricHealthPaths2["stat-sig"] = "stat-sig";
  return MAUIMetricHealthPaths2;
})(MAUIMetricHealthPaths || {});
var MAUIPreviewScorecardPaths = /* @__PURE__ */ ((MAUIPreviewScorecardPaths2) => {
  MAUIPreviewScorecardPaths2["published-versions"] = "published-versions";
  MAUIPreviewScorecardPaths2["recent-preview-analysis"] = "recent-preview-analysis";
  return MAUIPreviewScorecardPaths2;
})(MAUIPreviewScorecardPaths || {});
var MAUIConfigurationNavPaneItems = /* @__PURE__ */ ((MAUIConfigurationNavPaneItems2) => {
  MAUIConfigurationNavPaneItems2["Datasource"] = "Datasource";
  MAUIConfigurationNavPaneItems2["Aggregation level"] = "Aggregation level";
  MAUIConfigurationNavPaneItems2["Experimentation configuration"] = "Experimentation configuration";
  MAUIConfigurationNavPaneItems2["Git repository"] = "Git repository";
  MAUIConfigurationNavPaneItems2["Access control"] = "Access control";
  MAUIConfigurationNavPaneItems2["Analysis defaults"] = "Analysis defaults";
  MAUIConfigurationNavPaneItems2["Preview scorecard settings"] = "Preview scorecard settings";
  return MAUIConfigurationNavPaneItems2;
})(MAUIConfigurationNavPaneItems || {});
var MAUIMetricHealthNavPaneItems = /* @__PURE__ */ ((MAUIMetricHealthNavPaneItems2) => {
  MAUIMetricHealthNavPaneItems2["Constant value metrics"] = "Constant value metrics";
  MAUIMetricHealthNavPaneItems2["Inactive metrics"] = "Inactive metrics";
  MAUIMetricHealthNavPaneItems2["Outlier check"] = "Outlier check";
  MAUIMetricHealthNavPaneItems2["Sensitivity check"] = "Sensitivity check";
  MAUIMetricHealthNavPaneItems2["Stat-sig frequency check"] = "Stat-sig frequency check";
  return MAUIMetricHealthNavPaneItems2;
})(MAUIMetricHealthNavPaneItems || {});
var MAUIPreviewScorecardNavPaneItems = /* @__PURE__ */ ((MAUIPreviewScorecardNavPaneItems2) => {
  MAUIPreviewScorecardNavPaneItems2["Published versions"] = "Published versions";
  MAUIPreviewScorecardNavPaneItems2["Recent preview analysis"] = "Recent preview analysis";
  return MAUIPreviewScorecardNavPaneItems2;
})(MAUIPreviewScorecardNavPaneItems || {});
export {
  MAUIConfigurationNavPaneItems,
  MAUIConfigurationPaths,
  MAUIDraftEntityPaths,
  MAUIEnrichmentPaths,
  MAUIEntityPaths,
  MAUIMODES,
  MAUIMetricHealthNavPaneItems,
  MAUIMetricHealthPaths,
  MAUIPivotNames,
  MAUIPreviewScorecardNavPaneItems,
  MAUIPreviewScorecardPaths
};
//# sourceMappingURL=MAUI.models.js.map
